<template>
  <span>
    <svg
      width="7.5"
      height="12"
      version="1.1"
      viewBox="0 0 7.5 12"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      :fill="color"
    >
      <metadata>
        <rdf:RDF>
          <cc:Work rdf:about>
            <dc:format>image/svg+xml</dc:format>
            <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type>
            <dc:title></dc:title>
          </cc:Work>
        </rdf:RDF>
      </metadata>
      <path d="M 0,1.5 1.5285,0 7.5,6 1.5285,12 0,10.5 4.5,6 Z" stroke-width=".5"></path>
    </svg>
  </span>
</template>

<script>
export default {
  name: "Arrow",
  props: ["color"]
}
</script>

